/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Bonisoft Backend API
 * Bonisoft Backend API
 * OpenAPI spec version: 1
 */

export type OrderType = typeof OrderType[keyof typeof OrderType];


export const OrderType = {
  Ascending: 'Ascending',
  Descending: 'Descending',
} as const;
